<template>
    <button 
        class="btn btn_lg btn_fav btn_icononly"   
        v-bind:class="{ active: this.inFavourites }"                         
        @click.prevent="inFavourites ? deleteFromFavourites(id) : addToFavourites(id)"><i
            class="f7-icons icon_lg">heart_circle</i></button>
</template>

<script>
    export default {
        props: ['id'],

        computed: {
            inFavourites() {
                return this.$store.state.favourites.items.find(x => x.id == this.id);
            }
        },

        methods: {
            addToFavourites() {
                this.$store.dispatch('favourites/addToFavourites', this.id)
            },
            
            deleteFromFavourites() {
                this.$store.dispatch('favourites/deleteFromFavourites', this.id)
            }
        },
    }
</script>
